import React from "react";
import { Heart, Coffee, ChefHat, Sparkles } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const features = [{
  title: "Verified Expertise & Detailed Inspections",
  description: "Our team conducts meticulous inspections to uncover hidden damage, ensuring every project meets the highest standards.",
  icon: ChefHat
}, {
  title: "High-Grade Materials with Longevity Guarantees",
  description: "We use industry-leading, high-performance materials backed by guarantees for lasting durability.",
  icon: Sparkles
}, {
  title: "Lifetime Warranty",
  description: "Provides peace of mind and protection against weather damage for years to come.",
  icon: Heart
}, {
  title: "Insurance Claim Specialists",
  description: "We specialize in navigating insurance claims and fighting for your coverage to restore your home after severe weather.",
  icon: Coffee
}];
export default function WhyHabeshaPastry() {
  return <section data-section-id="223936" id="the-eagle-advantage" className="relative py-24 md:py-32 dark bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[25rem] md:text-[40rem] font-default leading-none text-primary/5">
          E
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Why Homeowners Choose Eagle
          </h2>
          <p className="text-lg text-secondary font-default">
            Enjoy faster project completion, transparent pricing, and a dedicated local team ensuring quality and peace of mind.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="bg-transparent border-none transition-all duration-300 group">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 border-2 border-primary flex items-center justify-center mb-4 group-hover:bg-primary/10 transition-colors">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="font-default font-bold text-xl text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-secondary leading-relaxed font-default">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}